import { useQuery } from "@tanstack/react-query";

import type { Result } from "@/shared/api";
import { apiGet, qk } from "@/shared/api";
import type { paths } from "@/api/types";

export type Dashboard = Result<paths["/api/v1/admin/dashboard"]["get"]>;

export function useDashboard() {
  return useQuery({
    queryKey: qk.dashboard(),
    queryFn: ({ signal }) => apiGet("/api/v1/admin/dashboard", { signal }),
  });
}
